import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Send, Clock, ArrowLeft } from "lucide-react";
import "../styles/ContactPage.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Votre message a été envoyé ! Nous vous répondrons dans les 24h.");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
        <Link to="/" className="privacy-back-button">
          <ArrowLeft size={20} />
          Retour à l'accueil
        </Link>
          <h1>Contactez-nous</h1>
          <p>Nous sommes là pour vous aider. Posez-nous toutes vos questions.</p>
        </div>
      </section>

      <div className="contact-container">
        <div className="contact-grid">
          <div className="contact-info">
            <h2>Informations de contact</h2>
            <p>Notre équipe est disponible pour répondre à toutes vos questions concernant UltimaTag.</p>
            
            <div className="contact-methods">
              <div className="contact-method">
                <div className="contact-icon">
                  <Phone size={24} />
                </div>
                <div>
                  <h3>Téléphone</h3>
                  <p>+225 07 12 20 49 86</p>
                  <p className="contact-hours">Lun-Ven: 8h-17h</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">
                  <Mail size={24} />
                </div>
                <div>
                  <h3>Email</h3>
                  <p>support@ultimatag.com</p>
                  <p className="contact-hours">Réponse sous 24h</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">
                  <MapPin size={24} />
                </div>
                <div>
                  <h3>Adresse</h3>
                  <p>Abidjan, Plateau</p>
                  <p>Immeuble CCIA, 24ème étage</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h2>Envoyez-nous un message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Nom complet *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Votre nom"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="votre@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Sujet *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Objet de votre message"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  placeholder="Décrivez votre demande..."
                />
              </div>

              <button type="submit" className="submit-button">
                <Send size={20} />
                Envoyer le message
              </button>
            </form>
          </div>
        </div>

        <div className="faq-section">
          <h2>Questions fréquentes</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Comment fonctionne UltimaTag ?</h3>
              <p>UltimaTag utilise des stickers QR uniques que vous collez sur vos objets. En cas de perte, la personne qui trouve l'objet scanne le QR code pour vous contacter ou le déposer dans un point rélais.</p>
            </div>

            <div className="faq-item">
              <h3>Comment savoir que mon objet a été retrouvé</h3>
              <p>Un SMS ou email vous sera envoyé dès qu'une personne aura trouvé votre objet.</p>
            </div>

            <div className="faq-item">
              <h3>Combien de temps faut-il pour recevoir mes stickers ?</h3>
              <p>Les stickers sont envoyés sous 24-48h après validation de votre commande. La livraison se fait par un service tiers partenaire.</p>
            </div>

           

            <div className="faq-item">
              <h3>Les stickers sont-ils résistants ?</h3>
              <p>Nos stickers sont certes en papier autocollants mais conçus pour durer plusieurs années même en usage intensif. Éviter de plonger dans un liquide.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}